import React from "react";
import { Download } from "lucide-react";
import { SensorFilterForm } from "../../components/calibrationModal/SensorFilterForm";
import type { UseSensorTypesReturn } from "../../components/calibrationModal/hooks/useSensorTypes";

interface SensorFiltersStepProps {
  individualCalibrationData: any;
  setIndividualCalibrationData: React.Dispatch<React.SetStateAction<any>>;
  sensorTypes: UseSensorTypesReturn;
  canGenerateSampleCsv: boolean;
  onGenerateSampleCsv: () => void;
}

export const SensorFiltersStep: React.FC<SensorFiltersStepProps> = ({
  individualCalibrationData,
  setIndividualCalibrationData,
  sensorTypes,
  canGenerateSampleCsv,
  onGenerateSampleCsv,
}) => {
  return (
    <div className="space-y-6">
      <SensorFilterForm
        individualCalibrationData={individualCalibrationData}
        setIndividualCalibrationData={setIndividualCalibrationData}
        sensorTypes={sensorTypes}
      />

      <div className="flex justify-center">
        <button
          type="button"
          onClick={onGenerateSampleCsv}
          disabled={!canGenerateSampleCsv}
          className="inline-flex items-center gap-2 btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Download className="h-4 w-4" />
          Generate Sample CSV
        </button>
      </div>
    </div>
  );
};
